import moment from 'moment-timezone'
import store from '../../store/store'
import { constants } from './constants'

export const TIMEZONE_LABELS = {
	'America/Anchorage': 'US/Alaska',
	'America/Chicago': 'US/Central',
	'America/Denver': 'US/Mountain',
	'America/Detroit': 'US/Michigan',
	'America/Fort_Wayne': 'US/East-Indiana',
	'America/Indiana/Knox': 'US/Indiana-Starke',
	'America/Los_Angeles': 'US/Pacific',
	'America/New_York': 'US/Eastern',
	'America/Phoenix': 'US/Arizona',
	'Pacific/Honolulu': 'US/Hawaii',
}

const localTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;
const storeUser = () => store.getState().user.user;

export const getTimezoneLabel = (timeZone) => TIMEZONE_LABELS[timeZone] || timeZone || ''

export const getUserTimezone = (user) => user?.settings?.time_zone || null

export const getUseDeviceTz = (user) => !!(user?.settings?.use_device_tz ?? user?.use_device_tz)

export const isDeviceTimezoneMode = () => getUseDeviceTz(storeUser())

const normalizedTimezones = {}

export const normalizeTimezone = (timeZone) => {
	if (!timeZone || moment.tz.zone(timeZone)) return timeZone || null
	if (!(timeZone in normalizedTimezones)) {
		const timezoneDB = constants.getTimezoneDB()
		const zones = Object.keys(timezoneDB).filter((zone) => timezoneDB[zone] === timeZone).map((zone) => zone.replace(/ /g, '_')).filter((zone) => moment.tz.zone(zone))
		normalizedTimezones[timeZone] = zones.find((zone) => [0, 6].every((month) => timeZone.includes(moment.tz([moment().year(), month, 15], zone).zoneAbbr()))) || zones[0] || null
	}
	return normalizedTimezones[timeZone]
}

export const resolveTimezone = (deviceTimeZone) => (isDeviceTimezoneMode() && normalizeTimezone(deviceTimeZone)) || getUserTimezone(storeUser())

export const headerTimestamp = (header, deviceTz) => {
	if (!header?.date || !header?.startTime) return null
	return moment.tz(`${header.date} ${header.startTime}`, normalizeTimezone(deviceTz) || getUserTimezone(storeUser()) || localTimezone()).valueOf()
}

export const toDateOnlyParam = (ts) => ts && moment.utc(String(ts), 'YYYYMMDDHHmmss').tz(resolveTimezone() || localTimezone()).format('YYYYMMDD')

export const toDateRangeParams = (startTs, endTs, allowDeviceTz = false) => ((allowDeviceTz && isDeviceTimezoneMode())
	? `start_date=${toDateOnlyParam(startTs)}&end_date=${toDateOnlyParam(endTs)}`
	: `start_ts=${startTs}&end_ts=${endTs}`)

export const convertRangeToDateOnly = (params, startKey, endKey, allowDeviceTz = false) => {
	if (!allowDeviceTz || !isDeviceTimezoneMode()) return params;

	[[startKey, 'start_date'], [endKey, 'end_date']].forEach(([key, dateKey]) => {
		if (params[key]) {
			params[dateKey] = toDateOnlyParam(params[key])
			delete params[key]
		}
	})
	return params
}

export const formatWithZoneAbbr = (momentObj, format) => (momentObj ? `${momentObj.format(format)} (${momentObj.zoneAbbr()})` : '')

export const formatWithZoneAbbrNode = (momentObj, format) => (momentObj
	? <>{momentObj.format(format)} <span className="timezone-abbr">({momentObj.zoneAbbr()})</span></>
	: '')

export const toStartDateParams = (startTs, useDeviceTimezone) => {
	if (useDeviceTimezone && isDeviceTimezoneMode()) return `start_date=${toDateOnlyParam(startTs)}`

	const tzname = resolveTimezone() || localTimezone()
	const offset = moment.tz(tzname).utcOffset()
	return `start_ts=${startTs}&timezone=UTC${offset > 0 ? '+' : ''}${offset / 60}&tzname=${tzname}`
}
